export default __webpack_public_path__ + "static/media/main.7593d267.mp4";